<template>
  <div class="card shadow" :class="[type === 'dark' ? 'bg-default': '',{loading:carregando}]">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">{{title}}</h3>
        </div>
        <div class="col text-right">
          <router-link to="/videos/novo">
            <base-button type="default" class="ml-4">Filtrar</base-button>
          </router-link>
        </div>
      </div>
    </div>

    <div class="table-responsive" v-if="!carregando">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark': ''"
        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
        tbody-classes="list"
        :data="itensPagina"
      >
        <template slot="columns">
          <th>Nome</th>
          <th>Telefone</th>
          <th>E-mail</th>
          <th>CRO/UF</th>
          <th>Total solicitações</th>
          <th></th>
        </template>

        <template slot-scope="{row}" :index="row.uid">
          <th scope="row">
            <span class="name mb-0 text-sm">{{row.nome}}</span>
          </th>
          <td>{{row.categoria}}</td>
          <td>
            <badge class="badge-dot mr-4" :type="getStatusColor(row.status)">
              <i :class="`bg-${getStatusColor(row.status)}`"></i>
              <span class="status">{{getStatusName(row.status)}}</span>
            </badge>
          </td>
          <td>{{row.visualizacoes}}</td>

          <td>
            <div class="d-flex align-items-center">
              <span class="completion mr-2">{{row.reproducaoMedia}}%</span>
              <div>
                <base-progress
                  :type="getStatusColor(row.status)"
                  :show-percentage="false"
                  class="pt-0"
                  :value="row.reproducaoMedia"
                />
              </div>
            </div>
          </td>

          <td class="botoes text-right">
            <router-link :to="'/videos/detalhes/'+row.uid">
              <base-button type="default" icon="fas fa-edit" size="sm"></base-button>
            </router-link>
            <base-button
              @click="preparaExclusao(row)"
              type="danger"
              icon="fas fa-trash"
              size="sm"
              class="ml-2"
            ></base-button>
          </td>
        </template>
      </base-table>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      v-if="paginacao.porPagina < tableData.length"
      :class="type === 'dark' ? 'bg-transparent': ''"
    >
      <base-pagination
        :perPage="paginacao.porPagina"
        v-model="paginacao.pagina"
        :total="tableData.length"
      ></base-pagination>
    </div>

    <modal
      :show.sync="exclusao.modal"
      gradient="danger"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">Muita calma nessa hora!</h6>

      <div class="py-3 text-center">
        <i class="fas fa-exclamation-triangle fa-3x"></i>
        <h4 class="heading mt-4">Atenção</h4>
        <p>Você tem certeza de que deseja excluir este vídeo?</p>
        <p>Tudo relacionado a ele será perdido, relatórios, visualizações e será também removido da lista de favoritos de quem o tiver adicionado.</p>
      </div>

      <template slot="footer">
        <base-button @click="excluirVideo" type="white">Sim, remover vídeo</base-button>
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="exclusao.modal = false"
        >Cancelar</base-button>
      </template>
    </modal>
  </div>
</template>
<script>
export default {
  name: "tabela-dentistas",
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  methods: {
    getStatusColor: function (val) {
      var cores = ["gray", "success", "danger"];
      return cores[val];
    },
    getStatusName: function (val) {
      var nomes = ["Não publicado", "Publicado", "Bloqueado"];
      return nomes[val];
    },
    preparaExclusao: function (video) {
      // Abre o modal e salva qual video tá tentando excluir
      this.exclusao.alvo = video;
      this.exclusao.modal = true;
    },
    excluirVideo: function () {

    },
  },
  computed: {
    itensPagina() {
      // Aqui vai automaticamente pegar apenas os itens que deveriam estar na página e retornar eles como itensPagina
      const start = (this.paginacao.pagina - 1) * this.paginacao.porPagina,
        end = start + this.paginacao.porPagina;
      return this.tableData.slice(start, end);
    },
  },
  data() {
    return {
      tableData: [],
      carregando: false,
      paginacao: {
        porPagina: 20,
        pagina: 1,
      },
      exclusao: {
        modal: false,
        alvo: null,
      },
    };
  },
  mounted() {
   
  },
};
</script>
<style>
</style>